export const Bio = {
  name: "Ravi Singh",
roles: [
  "Full Stack Developer",
  "MERN Stack Specialist",
  "Frontend & UI Engineer",
  "Backend & API Architect",
],

  description: "Full Stack MERN Developer crafting scalable web applications with React.js, Node.js, Express.js, and MongoDB. Committed to clean code, performance, and seamless user experiences.",
  github: "https://github.com/RaviSingh733/",
  resume:
    "https://drive.google.com/file/d/1fvLAGg3HJyBTYH28FsFHW1_EucD7alSs/view?usp=sharing",
    instagram: "https://www.instagram.com/legendravi733/?hl=en",
  linkedin: "https://in.linkedin.com/",
  twitter: "https://x.com/legendravi733",
  insta: "https://www.instagram.com/legendravi733/?hl=en",
  facebook: "https://www.facebook.com/LegendRavi73/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "HTML5", image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png" },
      { name: "CSS3", image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg" },
      { name: "JavaScript", image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" },
      { name: "React.js", image: "https://cdn.worldvectorlogo.com/logos/react-2.svg" },
      { name: "Next.js", image: "https://cdn.worldvectorlogo.com/logos/next-js.svg" },
      { name: "Tailwind CSS", image: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" },
      { name: "Redux Toolkit", image: "https://redux.js.org/img/redux.svg" },
      { name: "Bootstrap", image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png" },
      { name: "GSAP", image: "https://seeklogo.com/images/G/greensock-gsap-icon-logo-13BB451E88-seeklogo.com.png" },
    ],
  },

 {
  title: "Backend",
  
  skills: [
    { name: "Node.js", image: "https://nodejs.org/static/images/logo.svg" },
    { name: "Express.js", image: "https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png" },
    { name: "REST APIs", image: "https://cdn-icons-png.flaticon.com/512/1031/1031780.png" },
    { name: "JWT Authentication", image: "https://cdn-icons-png.flaticon.com/512/2554/2554978.png" },
    { name: "Socket.IO", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQauk75ZXxBsbTQv9YuPNvUxwWD2qADpaLxPQFKSDkHoabqT445viRXyXqB&s=10" },
    { name: "Mongoose", image: "https://icon.icepanel.io/Technology/svg/Mongoose.js.svg" },
  ],
},

  {
  title: "Databases",
  skills: [
    { name: "MongoDB", image: "https://icon.icepanel.io/Technology/svg/MongoDB.svg" },
    { name: "MySQL", image: "https://upload.wikimedia.org/wikipedia/en/d/dd/MySQL_logo.svg" },
    { name: "PostgreSQL", image: "https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg" },
    { name: "Microsoft SQL Server", image: "https://img.icons8.com/color/512/microsoft-sql-server.png" },
    { name: "SQLite", image: "https://upload.wikimedia.org/wikipedia/commons/3/38/SQLite370.svg" },
    { name: "MariaDB", image: "https://upload.wikimedia.org/wikipedia/commons/c/c9/MariaDB_Logo.png" },
    { name: "Firebase", image: "https://img.icons8.com/color/512/firebase.png" },
    { name: "Redis", image: "https://icon.icepanel.io/Technology/svg/Redis.svg" },
    { name: "Oracle Database", image: "https://img.icons8.com/color/512/oracle-logo.png" },
    { name: "Cassandra", image: "https://icon.icepanel.io/Technology/svg/Apache-Cassandra.svg" },
  ],
},
  {
  title: "Programming Languages",
  skills: [
    { name: "JavaScript", image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" },
    { name: "TypeScript", image: "https://img.icons8.com/color/512/typescript.png" },
    { name: "Java", image: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/181_Java_logo_logos-512.png" },
    { name: "C", image: "https://img.icons8.com/color/512/c-programming.png" },
    { name: "C++", image: "https://img.icons8.com/color/512/c-plus-plus-logo.png" },
    { name: "C#", image: "https://img.icons8.com/color/512/c-sharp-logo.png" },
    { name: "Python", image: "https://img.icons8.com/color/512/python.png" },
    { name: "PHP", image: "https://img.icons8.com/officel/512/php-logo.png" },
  ],
},

  {
    title: "Tools & Platforms",
    skills: [
      { name: "Git", image: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg" },
      { name: "GitHub", image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" },
      { name: "Postman", image: "https://www.svgrepo.com/show/354202/postman-icon.svg" },
      { name: "Firebase", image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" },
      { name: "Vercel", image: "https://assets.vercel.com/image/upload/v1662130559/front/favicon/vercel/180x180.png" },
      { name: "Netlify", image: "https://upload.wikimedia.org/wikipedia/commons/9/97/Netlify_logo_%282%29.svg" },
      { name: "Google Cloud", image: "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg" },
      { name: "VS Code", image: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg" },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D560BAQHWDYEWXkPfTg/company-logo_200_200/company-logo_200_200/0/1719047606096/octanetsolutions_logo?e=2147483647&v=beta&t=RFsKKYn-T-S9bMbG9po783ybKJfSTBvKq4zoJh6BtRk",
    role: "Web Developer Intern",
    company: "OctaNet Services Pvt. Ltd.",
    date: "January 2025 - February 2025",
    desc: "Worked on building responsive and user-friendly web applications using React.js. Contributed to frontend development and assisted in creating RESTful APIs using Node.js and Express.",
    skills: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Tailwind CSS",
      "Git",
      "GitHub",
      "Postman",
      "Vercel",
      "Netlify",
    ],
    doc: "https://drive.google.com/file/d/1gWN_-babVtkKt0KJ-wrugbnoQeIkBVKX/view",
  },

  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSo0VkgFPrK2eIZ2rbMGF9eKEBRUTeuzit0EQ&s",
    role: "Full Stack Developer",
    company: "Nethues Technologies Pvt. Ltd.",
    date: "June 2025 - Present",
    desc: "Developing scalable and high-performance web applications using the MERN stack. Building RESTful APIs, integrating frontend with backend, and working on real-world client projects.",
    skills: [
      "HTML5",
      "CSS3",
      "JavaScript (ES6+)",
      "React.js",
      "Next.js",
      "Tailwind CSS",
      "Bootstrap",
      "GSAP",
      "Node.js",
      "Express.js",
      "MongoDB",
      "MySQL",
      "REST APIs",
      "Git",
      "GitHub",
      "Postman",
      "Vercel",
      "Netlify",
      "Firebase",
      "VS Code",
      "Figma",
    ],
  },
  {
  id: 1,
  img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSo0VkgFPrK2eIZ2rbMGF9eKEBRUTeuzit0EQ&s",
  role: "Senior Web Developer",
  company: "Nethues Technologies Pvt. Ltd.",
  date: "Jan 2026 - Present",
  desc: "Leading the development of scalable, secure, and high-performance web applications using the MERN stack. Architecting full-stack solutions, optimizing application performance, mentoring developers, and delivering enterprise-grade client projects. Collaborating with cross-functional teams to build modern, responsive, and user-centric digital products.",
  skills: [
    "HTML5",
    "CSS3",
    "JavaScript (ES6+)",
    "TypeScript",
    "React.js",
    "Next.js",
    "Redux Toolkit",
    "Tailwind CSS",
    "Bootstrap",
    "Material UI",
    "GSAP",
    "Node.js",
    "Express.js",
    "MongoDB",
    "MySQL",
    "REST APIs",
    "JWT Authentication",
    "Socket.io",
    "Git",
    "GitHub",
    "CI/CD",
    "Docker",
    "Postman",
    "Vercel",
    "Netlify",
    "Firebase",
    "AWS",
    "VS Code",
    "Figma",
    "Agile/Scrum"
  ],
}
];


  export const certificates = [
  {
    id: 1,
    title: "Web Development Internship",
    issuer: "OctaNet Services Pvt. Ltd.",
    date: "February 2025",
    image: "/images/octanet-certificate.jpg",
    link: "YOUR_CERTIFICATE_LINK",
  },

  {
    id: 2,
    title: "React.js Development",
    issuer: "Coursera",
    date: "2025",
    image: "/images/react-certificate.jpg",
    link: "YOUR_CERTIFICATE_LINK",
  },

  {
    id: 3,
    title: "Full Stack MERN Development",
    issuer: "Udemy",
    date: "2025",
    image: "./",
    link: "YOUR_CERTIFICATE_LINK",
  },
  
];

export const education = [
 {
  id: 0,
  img: "https://content3.jdmagicbox.com/comp/firozabad/a5/9999p5612.5612.170330091751.c3a5/catalogue/j-s-university-shikohabad-firozabad-universities-oiveb25czn.jpg",
  school: "JS University, Shikohabad",
  date: "June 2023 - June 2026",
  desc: "Completed Bachelor of Computer Applications (BCA) with specialization in software development, database management, and web technologies.",
  degree: "Bachelor of Computer Applications (BCA)"
},
  {
    id: 1,
    img: "https://www.jagranimages.com/images/newimg/18102020/18_10_2020-18mrj26_20902700_18718.jpg",
    school: "GSVS Inter College, Maharajganj, Uttar Pradesh",
    date: "Apr 2022 - Apr 2023",
    desc: "Completed higher secondary education with a focus on Physics, Chemistry, and Biology (PCB).",
    degree: "UP Board (Class XII)",
  },
  {
    id: 2,
    img: "https://www.jagranimages.com/images/newimg/18102020/18_10_2020-18mrj26_20902700_18718.jpg",
    school: "GSVS Inter College, Maharajganj, Uttar Pradesh",
    date: "Apr 2020 - Apr 2021",
    desc: "Completed secondary education with a focus on Science and Mathematics.",
    degree: "UP Board (Class X)",
  },
];

export const projects = [
  {
    id: 1,
    title: "PowerFit Gym Website",
    date: "2026",
    description:
      "A modern and responsive fitness website built using React and Tailwind CSS. Features smooth animations with Framer Motion, reusable components, and a clean UI/UX optimized for all devices.",
    image: "gym.png",
    tags: [
      "React.js",
      "Tailwind CSS",
      "Framer Motion",
      "Vite"
    ],
    category: "web app",
    webapp: "https://powerfits.netlify.app/",
    github: "https://github.com/RaviSingh733/Gym-Website"
  },

  {
  id: 2,
  title: "Restaurant Website",
  date: "2026",
  description:
    "A responsive restaurant website with a modern UI, built using React and Tailwind CSS.",
  image: "/restaurant.png", // ✔ correct
  tags: ["React.js", "Tailwind CSS", "JavaScript", "Vite"],
  category: "web app",
  webapp: "https://royalspices.netlify.app/",
  github: "https://github.com/RaviSingh733/Restaurant-Website"
},

  {
    id: 3,
    title: "Travel Website",
    date: "2024",
    description:
      "A responsive travel website built using HTML, CSS, and JavaScript. Features interactive UI elements and clean navigation for exploring travel destinations.",
    image: "travel.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript"
    ],
    category: "web app",
    webapp: "https://travelwebsite0.netlify.app/",
    github: "https://github.com/RaviSingh733/TravelWebsite"
  }
];


